import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Increíble la claridad con la que explica la neutralización. Mis rubios ahora son perfectos.',
  name: 'Valeria P.',
  role: 'Estilista Senior'
}, {
  quote: 'Las plantillas de diagnóstico me ahorran muchísimo tiempo y me dan una imagen súper profesional.',
  name: 'Marcos T.',
  role: 'Dueño de Salón'
}, {
  quote: 'Por fin entiendo la lógica detrás de las mezclas. Ya no tengo miedo a que el color quede manchado.',
  name: 'Elena F.',
  role: 'Colorista'
}, {
  quote: 'Es la mejor inversión que hice para mi formación. El material es súper práctico y directo.',
  name: 'Romina S.',
  role: 'Peluquera Profesional'
}, {
  quote: 'Me cambió la forma de trabajar. Ahora mis clientas notan la diferencia en la precisión del color.',
  name: 'Julieta M.',
  role: 'Especialista en Color'
}, {
  quote: 'Súper completo. Los bonos son herramientas que uso todos los días en el salón.',
  name: 'Facundo L.',
  role: 'Estilista'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-white py-16 px-5" data-id="element-302">
      <div className="max-w-4xl mx-auto" data-id="element-303">
        <h2 className="text-2xl md:text-3xl font-black text-center text-slate-900 mb-4" data-id="element-304">
          💬 Profesionales reales, resultados reales
        </h2>
        <p className="text-sm text-slate-400 text-center mb-12 font-bold uppercase tracking-widest" data-id="element-305">
          Esto dicen quienes ya aplican el sistema en su trabajo
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-306">
          {comments.map((c, i) => <div key={i} className="bg-slate-50 border border-slate-100 p-6 rounded-2xl transition-all hover:bg-white hover:shadow-lg flex flex-col justify-between" data-id="element-307">
              <div data-id="element-308">
                <div className="flex gap-1 mb-3" data-id="element-309">
                  {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-[#C8A96B] text-[#C8A96B]" data-id="element-310" />)}
                </div>
                <p className="text-slate-600 italic text-sm mb-6 leading-relaxed font-medium" data-id="element-311">
                  "{c.quote}"
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-312">
                <div className="w-8 h-8 rounded-full bg-[#C8A96B]/10 flex items-center justify-center text-[#C8A96B] font-bold text-xs" data-id="element-313">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-314">
                  <p className="font-bold text-slate-900 text-xs" data-id="element-315">{c.name}</p>
                  <p className="text-[9px] text-slate-400 font-black uppercase tracking-widest" data-id="element-316">
                    {c.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}